var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPopUpCloseButton = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 40,
    height: 40
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_1260_10186_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    "data-figma-bg-blur-radius": 4,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L21.9792 21.9792",
    stroke: "#323429",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9795 10L10.0003 21.9792",
    stroke: "#323429",
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1260_10186_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(4 4)",
    cx: 16,
    cy: 16,
    r: 16
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopUpCloseButton);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGZvcmVpZ25PYmplY3QgeD0iLTQiIHk9Ii00IiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiPjxkaXYgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGh0bWwiIHN0eWxlPSJiYWNrZHJvcC1maWx0ZXI6Ymx1cigycHgpO2NsaXAtcGF0aDp1cmwoI2JnYmx1cl8wXzEyNjBfMTAxODZfY2xpcF9wYXRoKTtoZWlnaHQ6MTAwJTt3aWR0aDoxMDAlIj48L2Rpdj48L2ZvcmVpZ25PYmplY3Q+PGNpcmNsZSBvcGFjaXR5PSIwLjUiIGRhdGEtZmlnbWEtYmctYmx1ci1yYWRpdXM9IjQiIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEwIDEwTDIxLjk3OTIgMjEuOTc5MiIgc3Ryb2tlPSIjMzIzNDI5IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0yMS45Nzk1IDEwTDEwLjAwMDMgMjEuOTc5MiIgc3Ryb2tlPSIjMzIzNDI5IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImJnYmx1cl8wXzEyNjBfMTAxODZfY2xpcF9wYXRoIj48Y2lyY2xlIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQgNCkiIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIvPgo8L2NsaXBQYXRoPjwvZGVmcz4KPC9zdmc+Cg==";